import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
import Form from "../../../../../forms/others/form/index.js";
import { SearcherFlightHotelProvider } from "../../context/index.js";
import useSearcherFlightHotelForm from "../../hooks/useSearcherFlightHotelForm.js";
import useSearcherFlightHotelTransformedProps from "../../hooks/useSearcherFlightHotelTransformedProps.js";
const SearcherFlightHotelRedirectingModal = /*#__PURE__*/ lazy(()=>import("../redirecting-modal/index.js"));
const SearcherFlightHotelForm = ({ children , ...rootProps })=>{
    const props = useSearcherFlightHotelTransformedProps(rootProps);
    const { isRedirecting , defaultValues , onSubmit  } = useSearcherFlightHotelForm(props);
    return /*#__PURE__*/ _jsx(Form, {
        onSubmit: onSubmit,
        defaultValues: defaultValues,
        children: /*#__PURE__*/ _jsxs(SearcherFlightHotelProvider, {
            value: props,
            children: [
                children,
                /*#__PURE__*/ _jsx(Suspense, {
                    fallback: null,
                    children: isRedirecting && /*#__PURE__*/ _jsx(SearcherFlightHotelRedirectingModal, {})
                })
            ]
        })
    });
};
export default SearcherFlightHotelForm;

//# sourceMappingURL=index.js.map